import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Layout, Menu, MenuProps } from "antd";
import { Content } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import ButtonCustom from "components/base/ButtonCustom";
import LoadingUserLayout from "components/ui/LoadingUserLayout";
import { MENU_USER_LIST } from "contants/menu-user";
import { useAppSelector } from "hooks/app-hook";
import { useVerify } from "hooks/useVerify";
import { WrapperLayout } from "layouts/WrapperLayout";
import _map from "lodash/map";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { selectUsername } from "store/auth";
import { selectProfileLoading } from "store/user";
import { selectProfile } from "store/user";
import { getProfile } from "store/user/user.thunk";
import { theme } from "styles/theme";
import { AppDispatch } from "types";

import { UserLayoutStyle } from "./index.style";

const UserLayout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const isProfileLoading = useSelector(selectProfileLoading);
  const username = useSelector(selectUsername);

  const profile = useAppSelector(selectProfile);

  const [collapsed, setCollapsed] = useState(true);

  const items: MenuProps["items"] = _map(MENU_USER_LIST, (item, index) => {
    return {
      ...item,
      key: (index + 1).toString(),
    };
  });

  const { isLoading } = useVerify();

  useEffect(() => {
    if (profile) return;

    const _username = localStorage.getItem("username") || username;
    dispatch(getProfile(_username));
  }, []);

  return (
    <WrapperLayout>
      <UserLayoutStyle>
        <Layout
          style={{
            minHeight: "calc(100vh - 180px)",
            backgroundColor: theme.backgroundColors.primary,
          }}
        >
          <Sider collapsed={collapsed} width={280} collapsedWidth={70}>
            <div style={{ padding: "10px 10px 0 10px" }}>
              <ButtonCustom
                type="primary"
                background_color={theme.backgroundColors.primary}
                block
                onClick={() => setCollapsed((prev) => !prev)}
              >
                {collapsed ? <ArrowRightOutlined /> : <ArrowLeftOutlined />}
              </ButtonCustom>
            </div>
            <Menu
              theme="dark"
              defaultSelectedKeys={["1"]}
              mode="inline"
              items={items}
            />
          </Sider>
          <Content>
            {isLoading || isProfileLoading ? <LoadingUserLayout /> : <Outlet />}
          </Content>
        </Layout>
      </UserLayoutStyle>
    </WrapperLayout>
  );
};

export default UserLayout;
